import React from 'react'
import './CardServicios.css'


function CardServicios({imagen, titulo, descripcion, color}) {
  return (
    <div className='contenedorCardServicio'>
        <div className='contenedorTitulo'>
            <div className='contenedor-logo' style={{backgroundColor: color}}>
                <img src={imagen} alt={titulo}/>
            </div>
            <h4 className='tituloServicio'>{titulo}</h4>
        </div>
        
        <p className='parrafoServicio'>{descripcion}</p>
    </div>
  )
}

export default CardServicios
